/**
 * 报价类型
 */
export const quotationTypes = [
    {
        id: 1,
        title: "承运商参考报价"
    },
    {
        id: 0,
        title: "合作承运商报价"
    },
    {
        id: 3,
        title: "客户运输报价"
    },
    {
        id: 2,
        title: "资源规划成本"
    }
    // {
    //     id: 2,
    //     title: '客户需求成本'
    // }
];

export const columnMap = {
    a: {
        title: "起运地",
        sort: 1,
        type: 1,
        key: "a",
        width: 180,
        importFormat: (val) => {
            return val;
        }
    },
    b: {
        title: "目的地",
        sort: 2,
        type: 2,
        key: "b",
        width: 180,
        importFormat: (val) => {
            return val;
        }
    },
    c: {
        title: "中转地",
        sort: 3,
        type: 3,
        key: "c",
        width: 160,
        format: (val) => {
            try {
                val = JSON.parse(val);
                val = val.transitPlaceOneName || "";
            } catch (error) {
                val = val;
            }
            return val;
        }
    },
    d: {
        title: "公里数",
        sort: 4,
        type: 5,
        key: "d",
        width: 120
    },
    e: {
        title: "时效(h)",
        sort: 5,
        type: 6,
        key: "e",
        width: 120
    },
    f: {
        title: "是否高速",
        sort: 6,
        type: 7,
        key: "f",
        width: 120
    },
    g: {
        title: "是否分拣",
        sort: 7,
        type: 8,
        key: "g",
        width: 120
    },
    h: {
        title: "最低收费",
        sort: 8,
        type: 9,
        key: "h",
        width: 120
    },
    i: {
        title: "节点类型",
        sort: 9,
        type: 10,
        key: "i",
        width: 120
    },
    j: {
        title: "备注",
        sort: 10,
        type: 11,
        key: "j",
        width: ""
    }
};

const filterNull = (string) => {
    if (typeof string === "undefined" || string === null || string.toString().length < 1) {
        return false;
    }
    return true;
};
export const costItemObjectToString = (qItem) => {
    let {
        text,
        title,
        carType, // 车类型ID
        carTypeName, // 车类型名称
        costUnitId, // 费用单位ID
        costUnitName, // 费用单位名称
        expenseItemId, // 费用项目ID
        expenseItemName, // 费用项目名称
        lowestFee, // 最低收费
        intervalCostUnitName, // 限制区间单位名称
        intervalCostUnitId, // 限制区间单位ID
        endValue, // 限制区间 end
        startValue, // 限制区间 start
        firstWeight // 首重
    } = qItem;
    // console.log('costItemObjectToString', qItem)
    intervalCostUnitName = intervalCostUnitName || "";
    let s1 = "",
        s2 = "",
        s3 = "",
        s4 = "",
        s5 = "";
    s1 = expenseItemName + "(" + costUnitName + ")";
    if (filterNull(lowestFee)) {
        s2 = ", ￥≥" + lowestFee;
    }
    if (filterNull(startValue) && filterNull(endValue)) {
        s3 = `, ${startValue}<${intervalCostUnitName ? intervalCostUnitName : costUnitName}≤${endValue}`;
    } else if (filterNull(startValue) && !filterNull(endValue)) {
        s3 = `, ${intervalCostUnitName ? intervalCostUnitName : costUnitName}>${startValue}`;
    } else if (!filterNull(startValue) && filterNull(endValue)) {
        s3 = `, ${intervalCostUnitName ? intervalCostUnitName : costUnitName}≤${endValue}`;
    }
    s4 = carTypeName ? `, ${carTypeName}` : "";
    s5 = `${expenseItemName}(${costUnitName}), ${costUnitName}≤${firstWeight}`;
    if (expenseItemId === 3 && expenseItemName === "首重") {
        return s5;
    }
    return s1 + s2 + s3 + s4;
};

export const dealResponse = function (list, { header }) {
    const { columns, costList } = header;
    const result = list
        .map((cell) => {
            const { quotationCellList } = cell;
            let row = {
                id: cell.id
            };
            for (const key in columnMap) {
                if (columnMap.hasOwnProperty(key)) {
                    const element = columnMap[key];
                    const target = quotationCellList.find((c) => c.type === element.type) || { value: "" };
                    if (element.format) {
                        target.value = element.format(target.value);
                    }
                    row[key] = target.value;
                }
            }
            costList.forEach((item, index) => {
                // const target = quotationCellList.find(c => c.type === 12 && costItemObjectToString(item).split(',').indexOf(c.title) > -1) || { value: '-' }
                const target = quotationCellList.find(
                    (c) => c.type === 12 && costItemObjectToString(item) === c.title
                ) || { value: "-" };
                row[`expense-${index}`] = target.value;
            });
            row.expenseCells = quotationCellList.filter((item) => item.type === 12);
            return row;
        })
        .map((item) => ({
            ...item,
            _noEdit: true,
            _noSave: true,
            _noDel: !item.isEdit
        }));
    // console.log('dealResponse', list, header, costList.map(item => costItemObjectToString(item)), result)
    return result;
};
